module.exports = __webpack_public_path__ + "files/a6443ec5f458fb70759297371d99a21c.svg";